import React from "react";
import classes from "./RightPaneHeader.scss";
import { IconButton } from "@toddle-edu/ds-web";
import { CloseOutlined } from "@toddle-edu/ds-icons";

const RightPaneHeader = props => {
  const { onClose, testId, title } = props;

  return (
    <div className={classes.container}>
      <div className={classes.leftContainer}>
        <h6>{title}</h6>
      </div>
      <IconButton
        size={"medium"}
        icon={<CloseOutlined />}
        onClick={onClose}
        type="plain"
        variant="neutral"
        testId={`${testId}-rightPane-close`}
        dsVersion="2.0"
      />
    </div>
  );
};

export default RightPaneHeader;
